import { h, Host } from "@stencil/core";
export class ProactiveCaseClosureModal {
    constructor() {
        this.successMessageWasShown = false;
        /**
         * Environment to use for API calls
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * Debug mode
         * @deprecated do not use in production
         */
        this.debug = false;
        this.handleClose = () => {
            this.modal.triggerClose();
        };
        this.handleModalClose = () => {
            if (this.successMessageWasShown) {
                window.location.reload();
            }
        };
    }
    render() {
        return (h(Host, { key: 'ce950a70e751cd50734818b21fc620d892f7b7ed' }, h("ux-modal", { key: 'fdd714c59a64255a42b62ffccafc879418c2517b', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: 'cebb93a6b90b40c0ed427fc6b3a1205e996c79d9' }, h("mf-proactive-case-closure", { key: 'c5eeb007f9c1bb243717330162ac0a88f44c76ce', callId: this.callId, locale: this.locale, onMfServiceCallCancel: () => this.handleClose(), onMfServiceCallSuccess: () => {
                this.handleClose();
                window.location.reload();
            }, onMfServiceCallShowSuccess: () => (this.successMessageWasShown = true), env: this.env, legacyApi: this.legacyApi, debug: this.debug })))));
    }
    static get is() { return "mf-proactive-case-closure-modal"; }
    static get properties() {
        return {
            "callId": {
                "type": "string",
                "attribute": "call-id",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "SIS case ID"
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "locale": {
                "type": "string",
                "attribute": "locale",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The locale to use for translations"
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "modalName": {
                "type": "string",
                "attribute": "modal-name",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Identifier for the modal - see ux.ui docs"
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "env": {
                "type": "string",
                "attribute": "env",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Environment to use for API calls"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"prod\""
            },
            "legacyApi": {
                "type": "boolean",
                "attribute": "legacy-api",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "deprecated",
                            "text": "only used until April 2025"
                        }],
                    "text": "use onprem Public API instead of azure"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            },
            "debug": {
                "type": "boolean",
                "attribute": "debug",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "deprecated",
                            "text": "do not use in production"
                        }],
                    "text": "Debug mode"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
//# sourceMappingURL=proactive-case-closure-modal.js.map
